import { render, staticRenderFns } from "./AnnouncementNotify.vue?vue&type=template&id=acb6a6be"
import script from "./AnnouncementNotify.vue?vue&type=script&lang=js"
export * from "./AnnouncementNotify.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementNotify.vue?vue&type=style&index=0&id=acb6a6be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports